import { Navigate } from 'react-router-dom';
import { useAuthentication } from '~auth/useAuthentication';

export const RoleBasedRedirect = () => {
  const { user } = useAuthentication();
  const tokenRoles = user['https://wave.ppds.com/user_roles'] ?? [];
  const hasZteAdmin = tokenRoles.includes('ZteAdmin');
  const hasWaveAdmin = tokenRoles.includes('WaveAdmin');
  if (hasZteAdmin && !hasWaveAdmin) {
    return <Navigate to="/zte" />;
  }
  return <Navigate to="/firmware" />;
};
